import { FC, useContext, useEffect } from 'react'
import styled from 'styled-components'
import { Files } from './Files'
import { Declaration as DeclarationType, RespFile } from 'modules/domain/types'
import Declaration from './Declaration'
import { SellerSpecification } from './SellerSpecification'
import { BuyerSpecification } from './BuyerSpecification'
import { Deal } from 'modules/domain/deal/types'
import { refetchFunc, useSingleEntity } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { Progress } from '@agro-club/agroclub-shared'
import { SpecsContext } from '../../SpecsContext'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-top: 2px;
`

type Props = {
  declaration: DeclarationType | undefined
  setSummary: (arg: boolean) => void
  declarationRefetch: refetchFunc
  declarationProgress: Progress
  deal: Deal
  dealRefetch: refetchFunc
}

export const DealFiles: FC<Props> = ({
  declarationRefetch,
  declaration,
  deal,
  dealRefetch,
  setSummary,
  declarationProgress,
}) => {
  const [dealFilesProgress, dealFiles, dealFilesRefetch] = useSingleEntity<RespFile[]>(endpoints.dealFileList(deal.id))
  const { sellerSpecInfo } = useContext(SpecsContext)

  const groupDataIsLoaded =
    declarationProgress === Progress.SUCCESS &&
    dealFilesProgress === Progress.SUCCESS &&
    sellerSpecInfo.progress === Progress.SUCCESS

  useEffect(() => {
    if (groupDataIsLoaded) {
      setSummary(!!dealFiles?.length || !!declaration?.number || !!sellerSpecInfo.data?.[0]?.price)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealFiles?.length, declaration?.number, sellerSpecInfo.data])

  const dealAndSpecRefectch = async () => {
    await Promise.all([sellerSpecInfo.refetch(), dealRefetch()])
  }

  return (
    <Wrapper>
      <SellerSpecification refetch={dealAndSpecRefectch} specification={sellerSpecInfo.data} />
      {deal.purchase_specification && <BuyerSpecification deal={deal} />}
      <Declaration declaration={declaration} declarationRefetch={declarationRefetch} />

      <Files progress={dealFilesProgress} dealFiles={dealFiles} refetch={dealFilesRefetch} />
    </Wrapper>
  )
}
